(function(){"use strict";var r;try{if(typeof document<"u"){var e=document.createElement("style");e.nonce=(r=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:r.content,e.appendChild(document.createTextNode('._contentInput_1gj84_1{position:relative;width:100%}._input_1gj84_6{width:100%;height:3.5rem;padding:1.125rem 1rem;font-family:var(--font-families-iberia-headline);font-size:var(--s);color:var(--grey-800-33, #333);border:.0625rem solid var(--color-neutrales-40, #ccc);background-color:var(--neutrals-white, #fff)}._label_1gj84_17{position:absolute;top:1.75rem;left:var(--s);font-family:var(--font-families-iberia-headline);font-size:var(--s);line-height:normal;color:var(--grey-700-66, #666);cursor:text;width:calc(100% - 2rem);white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform:translateY(-50%);transition:top ease,transform .25s}._input_1gj84_6:focus{border-color:var(--primary-orange, #d68726);outline:none}._input_1gj84_6:disabled{background-color:var(--grey-200, #eee)}._input_1gj84_6:not(:placeholder-shown),._input_1gj84_6:focus{padding:1.5625rem 1rem .6875rem}._input_1gj84_6:focus+._label_1gj84_17,._input_1gj84_6:not(:placeholder-shown)+._label_1gj84_17{top:.6875rem;font-family:var(--font-families-verdana);font-size:.6875rem;text-transform:uppercase;color:var(--grey-700-66, #666);transform:translate(0)}._input_1gj84_6[type=number]{-moz-appearance:textfield}._input_1gj84_6::-webkit-outer-spin-button,._input_1gj84_6::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}._information_1gj84_72{display:flex;justify-content:flex-end;width:100%;padding:.625rem .9375rem;color:var(--grey-700-66, #666);background-color:var(--grey-100-fa, #fafafa)}._errorBorder_1gj84_81{border:.0625rem solid var(--primary-red-700, #a8191a)}._alert_185w5_1{display:flex;justify-content:flex-start;width:100%;padding:.625rem .9375rem;color:var(--neutrals-white, #fff);background-color:var(--primary-red-700, #a8191a)}._inputContainer_8dxem_1{display:grid;grid-template-columns:1.5rem auto;gap:var(--xxs)}._input_8dxem_1{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;background-color:var(--neutrals-white);border-radius:200rem;border:.0625rem solid var(--grey-700-66, #666);height:1.5rem;width:1.5rem;outline:none;display:grid;place-content:center;cursor:pointer}._input_8dxem_1[data-state-invalid=true]{border:.0625rem solid var(--primary-red-700, #a8191a)}input[type=radio]._input_8dxem_1:focus{outline:none;border:.0625rem solid var(--primary-orange, #d68726)}._input_8dxem_1:before{transition:.12s transform ease-in-out;content:"";border-radius:999rem;width:var(--xxs);height:var(--xxs);background-color:var(--primary-red-600);transform:scale(0)}._input_8dxem_1:checked:before{transform:scale(2)}._input_8dxem_1:disabled{background-color:var(--grey-200, #eee)}._label_8dxem_51{color:var(--grey-800-33, #333);font-size:.8125rem;line-height:var(--s);font-style:normal;font-family:var(--font-families-verdana);padding-top:.25rem}._radioGroupChildren_8dxem_60{display:flex;flex-direction:row;gap:2rem}._radioGroupChildrenVertical_8dxem_66{flex-direction:column;gap:var(--s)}._radioGroupContainer_8dxem_71{display:flex;flex-direction:column;gap:var(--s)}')),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { jsx as n, jsxs as h } from "react/jsx-runtime";
import G, { clsx as f } from "clsx";
import l, { forwardRef as v, useId as N } from "react";
import { T as C } from "./Icon-COuuXGxa.js";
const b = "_contentInput_1gj84_1", g = "_input_1gj84_6", R = "_label_1gj84_17", y = "_information_1gj84_72", B = "_errorBorder_1gj84_81", m = {
  contentInput: b,
  input: g,
  label: R,
  information: y,
  errorBorder: B
}, j = "_alert_185w5_1", $ = {
  alert: j
};
function I({ children: e, className: r, ...o }) {
  return /* @__PURE__ */ n(C, { as: "span", font: "verdana", size: "md-regular", role: "alert", className: G($.alert, r), ...o, children: e });
}
const w = v(
  ({ label: e, errorMessage: r, information: o, name: s, id: t, type: c, ...u }, p) => {
    const a = N(), i = t ?? a, _ = r ? i + "-error" : void 0;
    return e = e.charAt(0).toUpperCase() + e.slice(1), /* @__PURE__ */ h("div", { className: m.contentInput, children: [
      /* @__PURE__ */ n(
        "input",
        {
          className: f(m.input, { [m.errorBorder]: !!r }),
          placeholder: " ",
          ref: p,
          type: c,
          name: s,
          id: i + "-input",
          "aria-errormessage": _,
          "aria-invalid": !!r,
          ...u
        }
      ),
      /* @__PURE__ */ n("label", { className: m.label, htmlFor: i + "-input", children: e }),
      r && /* @__PURE__ */ n(I, { id: _, children: r }),
      o && /* @__PURE__ */ n(C, { className: m.information, as: "span", font: "verdana", size: "lg-regular", children: o })
    ] });
  }
);
w.displayName = "InputText";
const E = "_inputContainer_8dxem_1", F = "_input_8dxem_1", T = "_label_8dxem_51", V = "_radioGroupChildren_8dxem_60", z = "_radioGroupChildrenVertical_8dxem_66", P = "_radioGroupContainer_8dxem_71", d = {
  inputContainer: E,
  input: F,
  label: T,
  radioGroupChildren: V,
  radioGroupChildrenVertical: z,
  radioGroupContainer: P
}, x = l.createContext(void 0);
function A({ children: e, errorMessage: r }) {
  return /* @__PURE__ */ n(x.Provider, { value: r, children: e });
}
function U() {
  return l.useContext(x);
}
const k = l.forwardRef(
  ({ label: e, name: r, id: o, className: s, value: t, ...c }, u) => {
    const p = l.useId(), a = o ?? p, i = U();
    return /* @__PURE__ */ h("div", { className: f(d.inputContainer, s), children: [
      /* @__PURE__ */ n(
        "input",
        {
          className: f(d.input),
          ref: u,
          type: "radio",
          name: r,
          value: t,
          id: a + "-input",
          "data-state-invalid": !!i,
          "aria-describedby": i,
          ...c
        }
      ),
      /* @__PURE__ */ n("label", { className: d.label, htmlFor: a + "-input", children: e })
    ] });
  }
);
k.displayName = "InputRadio";
const q = l.forwardRef(
  ({ direction: e = "horizontal", children: r, id: o, className: s, errorMessage: t, ariaLabel: c, ...u }, p) => {
    const a = l.useId(), i = o ?? a, _ = t ? i + "-error" : void 0;
    return /* @__PURE__ */ n(A, { errorMessage: _, children: /* @__PURE__ */ h(
      "div",
      {
        className: f(d.radioGroupContainer, s),
        ...u,
        ref: p,
        role: "radiogroup",
        "aria-errormessage": t ? i + "-error" : void 0,
        "aria-invalid": !!t,
        "aria-label": c,
        children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: f(d.radioGroupChildren, e === "vertical" && d.radioGroupChildrenVertical),
              children: r
            }
          ),
          t && /* @__PURE__ */ n(I, { id: _, children: t })
        ]
      }
    ) });
  }
);
q.displayName = "InputRadioGroup";
export {
  I as F,
  w as I,
  k as a,
  q as b
};
